export const NO_CUSTOM_PAGES_COPY = 'No custom pages have been created for this site yet';
